import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import { navigatorTourStarted } from './actions';
import { getStoredHasSeenNavigatorTour } from './navigatorPreferences';

const markAsSeen = (): boolean => true;

export const hasSeenTourInThisBrowser$ = persistentReducedStream(
  'hasSeenTourInThisBrowser$',
  getStoredHasSeenNavigatorTour(),
  [reducer(navigatorTourStarted, markAsSeen)]
);
